import { render } from "./allcustomers.vue?vue&type=template&id=a2d47ece"
import script from "./allcustomers.vue?vue&type=script&lang=js"
export * from "./allcustomers.vue?vue&type=script&lang=js"

import "./allcustomers.vue?vue&type=style&index=0&id=a2d47ece&lang=css"
import "./allcustomers.vue?vue&type=style&index=1&id=a2d47ece&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__